// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"6de4a789","112":"53379819","408":"71471ae6","721":"6d3ada1d"}[chunkId] + ".chunk.css";
};